<script setup lang="ts">
import { UIButton } from '@gohighlevel/ghl-ui'
import { Image01Icon } from '@gohighlevel/ghl-icons/24/outline'
import {
  AltTypes,
  DigitalDelivery,
  EmitterKeys,
  MediaCenterType,
  MediaEvents,
} from '../../types'
import { onMounted, onUnmounted } from 'vue'
import { useEmitter } from '../../composition'

const props = defineProps({
  handshake: {
    type: Object,
    default: undefined,
    required: true,
  },
  altType: {
    type: String,
    default: AltTypes.LOCATION,
  },
  locationId: {
    type: String,
    required: true,
    default: '',
  },
  allowedExtensions: {
    type: Array,
    default: () => ['documents', 'image', 'video', 'audio'],
  },
  maxUploadSize: {
    type: Object,
    default: () => {
      return {}
    },
  },
  companyId: {
    type: String,
    required: true,
    default: '',
  },
  selfHosted: {
    type: Boolean,
    default: false,
  },
  contentType: {
    type: String,
    enum: MediaCenterType,
    required: false,
  },
})

const emitter = useEmitter()
const emit = defineEmits([MediaEvents.SELECTED_MEDIA])

const openMediaLibrary = () => {
  const settings = {
    companyId: props.companyId,
    altId: props.locationId,
    altType: props.altType,
    allowedExtensions: props.allowedExtensions,
    maxUploadSize: props.maxUploadSize,
    selfHosted: props.selfHosted,
    ...(props.contentType && { contentType: props.contentType }),
    contentAi: false,
    allowMultipleFileInsertion: false,
  }

  props.handshake.then((parent: any) => {
    parent.emit(EmitterKeys.OPEN_MEDIA_LIBRARY, settings)
  })
}

onUnmounted(() => {
  emitter.off(EmitterKeys.SELECTED_MEDIA_FILE)
})

onMounted(() => {
  emitter.on(EmitterKeys.SELECTED_MEDIA_FILE, (data: DigitalDelivery) => {
    emit(MediaEvents.SELECTED_MEDIA, data)
  })
})
</script>

<template>
  <UIButton
    id="image-picker-from-media-library"
    class="ml-2"
    variant="outline"
    @click="openMediaLibrary"
  >
    <Image01Icon class="w-4 h-4" />
  </UIButton>
</template>
